import React from "react";
import { NormalizedNutritionV2 } from "../type";
import TileGrid from "./TileGrid";
import { ReadOnlyFieldConfig } from "../ReadOnlyField";

type Props = {
  data: NormalizedNutritionV2;
  openPopperId: string | null;
  setOpenPopperId: React.Dispatch<React.SetStateAction<string | null>>;
};

const WorkoutFuelsTab = ({ data, openPopperId, setOpenPopperId }: Props) => {
  const { workoutFuels } = data;
  const hasPre = workoutFuels.preWorkoutMeals.length > 0;
  const hasPost = workoutFuels.postWorkoutMeals.length > 0;

  // Row-major order: tiles flow left→right, wrapping every 3 columns.
  // "Workout-specific meals" leads — it summarises which slots are in use, so
  // it reads before the slots themselves. It used to render on Eating Pattern,
  // reaching across sections; here it sits with the data it belongs to.
  const tiles: ReadOnlyFieldConfig[] = [
    {
      label: "Workout-specific meals",
      value: workoutFuels.workoutSpecificMeals,
      fieldKey: "workout-specific-meals",
    },
  ];

  if (hasPre) {
    tiles.push({
      label: "Pre-workout meals",
      value: workoutFuels.preWorkoutMeals.join(", "),
      fieldKey: "pre-workout-meals",
      items: workoutFuels.preWorkoutMeals.map((name) => ({
        name,
        preferred: true,
      })),
    });
    tiles.push({
      label: "Meal it replaces",
      value: workoutFuels.preWorkoutReplaces,
      fieldKey: "pre-workout-replaces",
    });
  }

  if (hasPost) {
    tiles.push({
      label: "Post-workout meals",
      value: workoutFuels.postWorkoutMeals.join(", "),
      fieldKey: "post-workout-meals",
      items: workoutFuels.postWorkoutMeals.map((name) => ({
        name,
        preferred: true,
      })),
    });
    tiles.push({
      label: "Meal it replaces",
      value: workoutFuels.postWorkoutReplaces,
      fieldKey: "post-workout-replaces",
    });
  }

  tiles.push({
    label: "Takes supplements",
    value: workoutFuels.takesSupplements,
    fieldKey: "takes-supplements",
  });
  tiles.push({
    label: "Current supplements",
    value:
      workoutFuels.supplements.length > 0
        ? workoutFuels.supplements.join(", ")
        : "No",
    fieldKey: "current-supplements",
    items: workoutFuels.supplements.map((name) => ({
      name,
      preferred: true,
    })),
  });

  return (
    <TileGrid
      tiles={tiles}
      openPopperId={openPopperId}
      setOpenPopperId={setOpenPopperId}
    />
  );
};

export default WorkoutFuelsTab;
